import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/axiosConfig';
import '../css/ChangePassword.css';

function ChangePassword() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    password: '',
    rpassword: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.rpassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await api.put(`/api/users/${id}/change-password`, formData);
      setSuccess('Password updated successfully');

      setTimeout(() => {
        navigate('/dashboard/users');
      }, 1500);

    } catch (err) {
      setError(err.response?.data?.message || 'Error updating password');
    }
  };

  return (
    <div className="change-password-container">
        <div className="change-password-card">
        <h1>Passwort ändern</h1>

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        <form onSubmit={handleSubmit}>
            <div className="form-group">
            <label>Neues Passwort</label>
            <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
            />
            </div>

            <div className="form-group">
            <label>Passwort wiederholen</label>
            <input
                type="password"
                name="rpassword"
                value={formData.rpassword}
                onChange={handleChange}
                required
            />
            </div>

            <div className="button-group">
            <button type="submit" className="submit-button">
                Speichern
            </button>
            <button
                type="button"
                className="cancel-button"
                onClick={() => navigate(-1)}
            >
                Abbrechen
            </button>
            </div>
        </form>
        </div>
    </div>
    );
}

export default ChangePassword;